"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const utils_1 = require("@loadsure/utils");
class Visibility {
    constructor(telematicsProvider, visibilityType, telematicsType) {
        this.telematicsProvider = telematicsProvider;
        this.visibilityType = visibilityType;
        this.telematicsType = telematicsType;
    }
    static fromObj(data) {
        const { telematicsProvider, visibilityType, telematicsType } = data;
        return new Visibility(telematicsProvider, utils_1.getEnumKeyOrUndefined("visibilityType", _1.eVisibilityType, visibilityType), utils_1.getEnumKeyOrUndefined("telematicsType", _1.eTelematicsType, telematicsType));
    }
    static empty() {
        return new Visibility("");
    }
    isEmpty() {
        return (this.telematicsProvider || this.visibilityType || this.telematicsType);
    }
}
exports.default = Visibility;
//# sourceMappingURL=visibility.class.js.map